export const englishCrmMessages = {
  resources: {
    companies: {
      name: "Company |||| Companies",
      forcedCaseName: "Company",
      fields: {
        name: "Company name",
        website: "Website",
        linkedin_url: "LinkedIn URL",
        phone_number: "Phone number",
        created_at: "Created at",
        nb_contacts: "Number of contacts",
        revenue: "Revenue",
        sector: "Sector",
        size: "Size",
        tax_identifier: "Tax Identifier",
        address: "Address",
        city: "City",
        zipcode: "Zip code",
        state_abbr: "State",
        country: "Country",
        description: "Description",
        context_links: "Context links",
        sales_id: "Account manager",
      },
      filters: {
        relationship: "Relationship",
        prospects: "Prospects",
        clients: "Clients",
      },
      empty: {
        description: "It seems your company list is empty.",
        title: "No companies found",
      },
      import: {
        title: "Import companies",
      },
      field_categories: {
        contact: "Contact",
        additional_info: "Additional information",
        address: "Address",
        context: "Context",
      },
      action: {
        create: "Create Company",
        edit: "Edit company",
        new: "New Company",
        show: "Show company",
      },
      added_on: "Added on %{date}",
      followed_by: "Followed by %{name}",
      followed_by_you: "Followed by you",
      no_contacts: "No contact",
      nb_contacts: "%{smart_count} contact |||| %{smart_count} contacts",
      nb_deals: "%{smart_count} deal |||| %{smart_count} deals",
      sizes: {
        one_employee: "1 employee",
        two_to_nine_employees: "2-9 employees",
        ten_to_forty_nine_employees: "10-49 employees",
        fifty_to_two_hundred_forty_nine_employees: "50-249 employees",
        two_hundred_fifty_or_more_employees: "250 or more employees",
      },
      autocomplete: {
        create_error: "An error occurred while creating the company",
        create_item: "Create %{item}",
        create_label: "Start typing to create a new company",
      },
    },
    clients: {
      name: "Client |||| Clients",
      forcedCaseName: "Client",
      fields: {
        name: "Brand",
        sector: "Sector",
        website: "Website",
        service_mode: "Service mode",
        services: "Contracted services",
        client_since: "Client since",
        sales_id: "Agency lead",
        main_contact_name: "Name",
        main_contact_role: "Role",
        main_contact_whatsapp: "WhatsApp",
        main_contact_email: "Email",
        content_approver: "Who approves content",
        managed_accounts: "Accounts we manage",
        client_notes: "Notes (likes, things to avoid, agreements)",
      },
      service_modes: {
        full_content: "Full content",
        creative_direction: "Creative direction only",
      },
      sections: {
        contact: "Main contact",
        service: "Service",
        contract: "Contract",
        accounts: "Accounts we manage",
        notes: "Notes",
        portal: "Portal access",
      },
      action: {
        convert: "Convert to client",
        converted: "The company is now a client",
        edit: "Edit profile",
        view_profile: "View client profile",
      },
      empty: {
        title: "No clients yet",
        description:
          'Open a company and click "Convert to client" to create its profile.',
      },
      contract: {
        monthly_fee: "Monthly fee",
        start_date: "Contract start",
        notes: "Contract notes",
        empty: "No contract value registered yet",
        saved: "Contract saved",
        per_month: "per month",
        admin_only: "Only administrators can see this section.",
      },
      accounts: {
        platform: "Platform",
        handle: "Account or link",
        notes: "Notes",
        empty: "No accounts registered yet",
        no_passwords: "Never store passwords here.",
      },
      portal: {
        coming_soon:
          "Inviting the client to the portal will be available in the next step.",
      },
      not_set: "Not set",
      nb_services: "%{smart_count} service |||| %{smart_count} services",
    },
    content_pieces: {
      undated:
        "No publish date: %{smart_count} piece |||| No publish date: %{smart_count} pieces",
      name: "Piece |||| Pieces",
      calendar: "Content calendar",
      menu: "Calendar",
      all_clients: "All clients",
      fields: {
        title: "Title",
        company_id: "Client",
        format: "Format",
        publish_date: "Publish date",
        due_date: "Internal delivery",
        assignee_id: "Assigned to",
        script: "Script or creative brief",
        caption: "Caption",
        status: "Status",
      },
      formats: {
        reel: "Reel",
        post: "Post",
        carousel: "Carousel",
        story: "Story",
        video: "Video",
        other: "Other",
      },
      statuses: {
        preparing: "In preparation",
        in_review: "In review",
        changes_requested: "Changes requested",
        approved: "Approved",
        published: "Published",
      },
      stats: {
        total: "Pieces this month",
      },
      filters: {
        all: "All",
      },
      action: {
        new: "New piece",
        edit: "Edit piece",
        send_to_review: "Send to client review",
        resend_to_review: "Send new version to review",
        mark_published: "Mark as published",
        back_to_preparing: "Back to preparation",
        add_version: "Add version",
        delete: "Delete piece",
      },
      versions: {
        title: "Versions",
        version: "Version %{number}",
        empty: "No file or link yet",
        upload: "Upload image or PDF",
        link: "Or paste a link (Drive, YouTube, Canva...)",
        note: "What changed (optional)",
        save: "Save version",
        need_file_or_link: "Add a file or a link",
        too_large: "The file is larger than 50 MB. Use a Drive link instead.",
        open: "Open",
        open_link: "Open the link",
        previous: "Previous",
        next: "Next",
        more: "more",
        less: "less",
        upload_hint:
          "For a carousel, pick several files at once: they show in that order. 50 MB max per file.",
        uploading: "Uploading...",
        open_in_drive: "Open in Drive",
        open_in_youtube: "Open in YouTube",
        open_in_canva: "Open in Canva",
        share_hint: "If it does not show, the file must be shared as 'Anyone with the link'.",
      },
      comments: {
        title: "Comments",
        empty: "No comments yet",
        placeholder: "Write a comment...",
        send: "Send",
        client: "Client",
      },
      approved_by: "Approved by %{name}",
      select_client: "Choose a client to create pieces",
      no_selection: "Select a piece in the calendar to see its details.",
      saved: "Piece saved",
      deleted: "Piece deleted",
      delete_confirm: "Delete this piece, its versions and comments?",
      no_clients:
        "There are no clients yet. Convert a company into a client to plan its content.",
      no_pieces_day: "No pieces this day.",
      weekdays: "Mon,Tue,Wed,Thu,Fri,Sat,Sun",
    },
    client_reports: {
      name: "Report |||| Reports",
      menu: "Reports",
      title: "Monthly reports",
      empty: "No reports published yet.",
      add: "Publish report",
      kind: "Area",
      kinds: {
        content: "Content and social media",
        paid_media: "Paid media",
        web: "Web",
        general: "General",
      },
      month: "Month",
      summary: "One-line summary (what happened this month)",
      file: "Report file (PDF or image)",
      link: "Or paste a link (Drive, Looker Studio...)",
      need_file_or_link: "Add a file or a link",
      saved: "Report published",
      open: "Open report",
      delete_confirm: "Delete this report?",
    },
    brand_assets: {
      menu: "My brand",
      title: "Brand kit",
      empty: "No brand material yet.",
      add: "Add brand material",
      kind: "Type",
      label: "Name",
      value_color: "Color code (#2F6BFF)",
      value_font: "Font name",
      value_other: "Note (optional)",
      file: "File (logo, PDF, image)",
      link: "Or paste a link",
      saved: "Brand material saved",
      copied: "Copied",
      open: "Open",
      delete_confirm: "Delete this item?",
      kinds: {
        logo: "Logos",
        color: "Colors",
        font: "Fonts",
        manual: "Brand manual",
        brief: "Brief",
        photo: "Photos",
        other: "Other",
      },
    },
    proposals: {
      name: "Proposal |||| Proposals",
      menu: "Proposals",
      empty: "No proposals yet.",
      create: "Create proposal",
      edit: "Edit proposal",
      view_pdf: "View and download PDF",
      download_pdf: "Download PDF",
      back: "Back",
      saved: "Proposal saved",
      deleted: "Proposal deleted",
      delete_confirm: "Delete this proposal?",
      fields: {
        title: "Proposal title",
        company_id: "Company",
        status: "Status",
        intro: "Introduction",
        items: "Services",
        service: "Service",
        description: "What it includes",
        monthly_price: "Monthly value",
        setup_fee: "One-time setup value (optional)",
        valid_until: "Valid until",
        terms: "Terms",
      },
      statuses: {
        draft: "Draft",
        sent: "Sent",
        accepted: "Accepted",
        rejected: "Rejected",
      },
      add_item: "Add service",
      monthly_total: "Monthly total",
      setup: "Setup",
      default_title: "Proposal for %{company}",
      default_intro:
        "This proposal brings together the services we discussed for %{company}, with what each one includes and its monthly value.",
      default_terms:
        "Values do not include the ad spend, which is paid directly to the platforms.\nNo minimum-term contracts.",
      document: {
        heading: "Commercial proposal",
        prepared_for: "Prepared for",
        attention: "Attn:",
        date: "Issue date",
        valid_until: "Valid until",
        service: "Service",
        monthly_value: "Monthly fee",
        subtotal: "Monthly subtotal",
        setup: "Setup (one-time)",
        total: "Monthly total",
        terms: "Terms",
        acceptance: "Acceptance",
        acceptance_text: "By signing this document, both parties accept the services, fees and terms described.",
        sign_for: "For %{name}",
        sign_fields: "Name, signature and date",
        contact: "CMG360 · Medellín, Colombia",
      },
    },
    contacts: {
      name: "Contact |||| Contacts",
      forcedCaseName: "Contact",
      field_categories: {
        background_info: "Background info",
        identity: "Identity",
        misc: "Misc",
        personal_info: "Personal info",
        position: "Position",
      },
      fields: {
        first_name: "First name",
        last_name: "Last name",
        last_seen: "Last seen",
        title: "Title",
        company_id: "Company",
        email_jsonb: "Email addresses",
        email: "Email",
        phone_jsonb: "Phone numbers",
        phone_number: "Phone number",
        linkedin_url: "LinkedIn URL",
        background: "Background info (bio, how you met, etc)",
        has_newsletter: "Has newsletter",
        sales_id: "Account manager",
      },
      action: {
        add: "Add contact",
        add_first: "Add your first contact",
        create: "Create contact",
        edit: "Edit contact",
        export_vcard: "Export to vCard",
        new: "New Contact",
        show: "Show contact",
      },
      background: {
        last_activity_on: "Last activity on %{date}",
        added_on: "Added on %{date}",
        followed_by: "Followed by %{name}",
        followed_by_you: "Followed by you",
        status_none: "None",
      },
      position_at: "%{title} at",
      position_at_company: "%{title} at %{company}",
      empty: {
        description: "It seems your contact list is empty.",
        title: "No contacts found",
      },
      import: {
        title: "Import contacts",
      },
      inputs: {
        genders: {
          male: "He/Him",
          female: "She/Her",
          nonbinary: "They/Them",
        },
        personal_info_types: {
          work: "Work",
          home: "Home",
          other: "Other",
        },
      },
      list: {
        error_loading: "Error loading contacts",
      },
      bulk_tag: {
        action: "Tag",
        back: "Back to tags",
        create_description:
          "Create a new tag and apply it to the selected contacts.",
        description:
          "Choose an existing tag or create a new one for the selected contacts.",
        empty: "No tags yet. Create one to tag the selected contacts.",
        error: "Failed to add tag to contacts",
        noop: "Selected contacts already have this tag",
        success:
          "Tag added to %{smart_count} contact |||| Tag added to %{smart_count} contacts",
        title: "Add tag to contacts",
      },
      merge: {
        action: "Merge with another contact",
        confirm: "Merge Contacts",
        current_contact: "Current Contact (will be deleted)",
        description: "Merge this contact with another one.",
        error: "Failed to merge contacts",
        merging: "Merging...",
        no_additional_data: "No additional data to merge",
        select_target: "Please select a contact to merge with",
        success: "Contacts merged successfully",
        target_contact: "Target Contact (will be kept)",
        title: "Merge Contact",
        warning_description:
          "All data will be transferred to the second contact. This action cannot be undone.",
        warning_title: "Warning: Destructive Operation",
        what_will_be_merged: "What will be merged:",
      },
      filters: {
        all_statuses: "All",
        before_last_month: "Before last month",
        before_this_month: "Before this month",
        before_this_week: "Before this week",
        managed_by_me: "Managed by me",
        search: "Search name, company...",
        this_week: "This week",
        today: "Today",
        tags: "Tags",
        tasks: "Tasks",
      },
      hot: {
        empty_change_status:
          'Change the status of a contact by adding a note to that contact and clicking on "show options".',
        empty_hint: 'Contacts with a "hot" status will appear here.',
        title: "Hot Contacts",
      },
    },
    deals: {
      name: "Deal |||| Deals",
      fields: {
        name: "Name",
        description: "Description",
        company_id: "Company",
        contact_ids: "Contacts",
        category: "Category",
        services: "Services",
        amount: "Budget",
        expected_closing_date: "Expected closing date",
        stage: "Stage",
      },
      action: {
        back_to_deal: "Back to deal",
        create: "Create deal",
        new: "New Deal",
      },
      field_categories: {
        misc: "Misc",
      },
      filters: {
        only_mine: "Only deals I manage",
      },
      archived: {
        action: "Archive",
        error: "Error: deal not archived",
        list_title: "Archived Deals",
        success: "Deal archived",
        title: "Archived Deal",
        view: "View archived deals",
      },
      inputs: {
        linked_to: "Linked to",
      },
      unarchived: {
        action: "Send back to the board",
        error: "Error: deal not unarchived",
        success: "Deal unarchived",
      },
      updated: "Deal updated",
      empty: {
        before_create: "before creating a deal.",
        description: "It seems your deal list is empty.",
        title: "No deals found",
      },
      import: {
        title: "Import deals",
      },
      invalid_date: "Invalid date",
    },
    notes: {
      name: "Note |||| Notes",
      forcedCaseName: "Note",
      fields: {
        status: "Status",
        date: "Date",
        attachments: "Attachments",
        contact_id: "Contact",
        deal_id: "Deal",
      },
      action: {
        add: "Add note",
        add_first: "Add your first note",
        delete: "Delete note",
        edit: "Edit note",
        update: "Update note",
        add_this: "Add this note",
      },
      sheet: {
        create: "Create note",
        create_for: "Create note for %{name}",
        edit: "Edit note",
        edit_for: "Edit note for %{name}",
      },
      deleted: "Note deleted",
      empty: "No notes yet",
      author_added: "%{name} added a note",
      you_added: "You added a note",
      me: "Me",
      list: {
        error_loading: "Error loading notes",
      },
      note_for_contact: "Note for %{name}",
      stepper: {
        hint: "Go to a contact page and add a note",
      },
      added: "Note added",
      inputs: {
        add_note: "Add a note",
        options_hint: "(attach files, or change details)",
        show_options: "Show options",
      },
      actions: {
        attach_document: "Attach document",
      },
      validation: {
        note_or_attachment_required: "A note or an attachment is required",
      },
    },
    sales: {
      delete: {
        button: "Delete user",
        title: "Delete %{name}?",
        description:
          "Their account is removed and they can no longer sign in. Their contacts, deals, tasks and notes move to you. This cannot be undone.",
        confirm: "Yes, delete",
        success: "User deleted",
        error: "Could not delete the user",
      },
      name: "User |||| Users",
      fields: {
        first_name: "First name",
        last_name: "Last name",
        email: "Email",
        secondary_email: "Secondary email",
        secondary_emails: "Secondary emails",
        administrator: "Admin",
        disabled: "Disabled",
      },
      create: {
        link_ready: "Access link ready for %{name}",
        link_hint:
          "Send it by WhatsApp. It works once; with it they choose their password. If it expires, open that user and create a new link.",
        copy: "Copy link",
        send_whatsapp: "Send by WhatsApp",
        done: "Done",
        whatsapp_message:
          "Hi %{name}! This is your access to the CMG360 platform: %{link}",
        error: "An error occurred while creating the user.",
        success:
          "User created. They will soon receive an email to set their password.",
        title: "Create a new user",
      },
      edit: {
        new_access_link: "Create new access link",
        error: "An error occurred. Please try again.",
        record_not_found: "Record not found",
        success: "User updated successfully",
        title: "Edit %{name}",
      },
      action: {
        new: "New user",
      },
    },
    tasks: {
      name: "Task |||| Tasks",
      forcedCaseName: "Task",
      fields: {
        text: "Description",
        due_date: "Due date",
        type: "Type",
        contact_id: "Contact",
        due_short: "due",
      },
      action: {
        add: "Add task",
        create: "Create task",
        edit: "Edit task",
      },
      actions: {
        postpone_next_week: "Postpone to next week",
        postpone_tomorrow: "Postpone to tomorrow",
        title: "task actions",
      },
      added: "Task added",
      deleted: "Task deleted successfully",
      dialog: {
        create: "Create task",
        create_for: "Create task for %{name}",
      },
      sheet: {
        edit: "Edit task",
        edit_for: "Edit task for %{name}",
      },
      empty: "No tasks yet",
      empty_list_hint: "Tasks added to your contacts will appear here.",
      filters: {
        later: "Later",
        overdue: "Overdue",
        this_week: "This week",
        today: "Today",
        tomorrow: "Tomorrow",
        with_pending: "With pending tasks",
      },
      regarding_contact: "(Re: %{name})",
      updated: "Task updated",
    },
    tags: {
      name: "Tag |||| Tags",
      action: {
        add: "Add tag",
        create: "Create new tag",
      },
      dialog: {
        color: "Color",
        create_title: "Create a new tag",
        edit_title: "Edit tag",
        name_label: "Tag name",
        name_placeholder: "Enter tag name",
      },
      empty: "No tags yet.",
    },
  },
  crm: {
    action: {
      reset_password: "Reset Password",
    },
    auth: {
      no_access: "This account no longer has access to the platform.",
      first_name: "First name",
      last_name: "Last name",
      confirm_password: "Confirm password",
      confirmation_required:
        "Please follow the link we just sent you by email to confirm your account.",
      recovery_email_sent:
        "If you're a registered user, you should receive a password recovery email shortly.",
      sign_in_failed: "Failed to log in.",
      sign_in_google_workspace: "Sign in with Google Workplace",
      signup: {
        create_account: "Create account",
        create_first_user:
          "Create the first user account to complete the setup.",
        creating: "Creating...",
        initial_user_created: "Initial user successfully created",
      },
      errors: {
        password_requirements:
          "The password needs at least one lowercase letter, one uppercase letter and one number.",
        password_too_short:
          "The password must have at least %{min} characters.",
        same_password:
          "The new password must be different from the previous one.",
        invalid_credentials: "Incorrect email or password.",
        email_not_confirmed: "This email has not been confirmed yet.",
        link_expired:
          "This access link already expired or was used. Ask the agency for a new one.",
        rate_limited: "Too many attempts. Wait a few minutes and try again.",
      },
      welcome_title: "Welcome to Atomic CRM",
    },
    common: {
      account_manager: "Account manager",
      activity: "Activity",
      added: "added",
      details: "Details",
      last_activity_with_date: "last activity %{date}",
      load_more: "Load more",
      misc: "Misc",
      past: "Past",
      read_more: "Read more",
      retry: "Retry",
      show_less: "Show less",
      copied: "Copied!",
      copy: "Copy",
      loading: "Loading...",
      me: "Me",
      task_count: "%{smart_count} task |||| %{smart_count} tasks",
    },
    changelog: {
      title: "Changelog",
    },
    activity: {
      added_company: "%{name} added company",
      you_added_company: "You added company",
      added_contact: "%{name} added",
      you_added_contact: "You added",
      added_note: "%{name} added a note about",
      you_added_note: "You added a note about",
      added_note_about_deal: "%{name} added a note about deal",
      you_added_note_about_deal: "You added a note about deal",
      added_deal: "%{name} added deal",
      you_added_deal: "You added deal",
      at_company: "at",
      to: "to",
      load_more: "Load more activity",
    },
    dashboard: {
      deals_chart: "Upcoming Deal Revenue",
      deals_pipeline: "Deals Pipeline",
      latest_activity: "Latest Activity",
      latest_activity_error: "Error loading latest activity",
      latest_notes: "My Latest Notes",
      latest_notes_added_ago: "added %{timeAgo}",
      stepper: {
        install: "Install Atomic CRM",
        progress: "%{step}/3 done",
        whats_next: "What's next?",
      },
      upcoming_tasks: "Upcoming Tasks",
    },
    data_import: {
      button: "Import CSV",
      complete:
        "Import complete. Imported %{importCount} records, with %{errorCount} errors",
      csv_file: "CSV File",
      error:
        "Failed to import this file, please make sure you provided a valid CSV file.",
      in_progress: "Import in progress…",
      progress:
        "Imported %{importCount} / %{rowCount} records, with %{errorCount} errors.",
      remaining_time: "Estimated remaining time:",
      resource: "Resource",
      sample_download: "Download CSV sample",
      sample_hint: "Here is a sample CSV file you can use as a template",
      start: "Start import",
      stop: "Stop import",
      stopped:
        "Import stopped. Imported %{importCount} records, with %{errorCount} errors",
      title: "Import data",
    },
    header: {
      import_data: "Import from JSON",
    },
    image_editor: {
      change: "Change",
      drop_hint: "Drop a file to upload, or click to select it.",
      editable_content: "Editable content",
      title: "Upload and resize image",
      update_image: "Update Image",
    },
    import: {
      action: {
        download_error_report: "Download the error report",
        import: "Import",
        import_another: "Import another file",
      },
      error: {
        unable: "Unable to import this file.",
      },
      idle: {
        description_1:
          "You can import sales, companies, contacts, companies, notes, and tasks.",
        description_2:
          "Data must be in a JSON file matching the following sample:",
      },
      status: {
        all_success: "All records were imported successfully.",
        complete: "Import complete.",
        failed: "Failed",
        imported: "Imported",
        in_progress:
          "Import in progress, please don't navigate away from this page.",
        some_failed: "Some records were not imported.",
        table_caption: "Import status",
      },
      title: "Import from JSON",
    },
    settings: {
      about: "About",
      companies: {
        sectors: "Sectors",
      },
      dark_mode_logo: "Dark Mode Logo",
      deals: {
        categories: "Categories",
        currency: "Currency",
        pipeline_help:
          "Select which deal stages should count as pipeline deals.",
        pipeline_statuses: "Pipeline Statuses",
        stages: "Stages",
      },
      light_mode_logo: "Light Mode Logo",
      notes: {
        statuses: "Statuses",
      },
      reset_defaults: "Reset to Defaults",
      save_error: "Failed to save configuration",
      saved: "Configuration saved successfully",
      saving: "Saving...",
      tasks: {
        types: "Types",
      },
      preferences: "Preferences",
      title: "Settings",
      app_title: "App Title",
      sections: {
        branding: "Branding",
      },
      validation: {
        duplicate: "Duplicate %{display_name}: %{items}",
        in_use:
          "Cannot remove %{display_name} that are still used by deals: %{items}",
        validating: "Validating\u2026",
        entities: {
          categories: "categories",
          stages: "stages",
        },
      },
    },
    access: {
      title: "Welcome to CMG360",
      description: "Tap the button to create your password and sign in.",
      continue: "Create my password",
      invalid:
        "This link was already used or has expired. Ask the agency for a new one.",
    },
    my_work: {
      subtitle: "This is what you are in charge of.",
      changes: "Changes requested",
      changes_empty: "No client has asked you for changes.",
      to_do: "To do",
      to_do_empty: "You have no pieces in preparation.",
      waiting: "Waiting for the client",
      waiting_empty: "Nothing pending approval.",
      to_publish: "Publish today and this week",
      to_publish_empty: "Nothing approved to publish in the next 7 days.",
      unassigned: "Pieces without an owner",
      sent_today: "Sent today",
      waiting_days: "%{smart_count} day ago |||| %{smart_count} days ago",
      today: "Today",
      overdue: "Overdue",
    },
    agency_dashboard: {
      content_month:
        "Content this month: %{smart_count} piece |||| Content this month: %{smart_count} pieces",
      deals_chart_hint:
        "Won in green, open deals weighted by stage in blue and lost in red, by the month the deal was created.",
      greeting: "Hi, %{name}",
      subtitle: "This is how the agency is doing today.",
      in_review: "Waiting for client approval",
      changes_requested: "Changes to make",
      active_clients: "Active clients",
      proposals_sent: "Proposals awaiting answer",
      upcoming: "Publishing in the next 7 days",
      upcoming_empty: "Nothing scheduled for the next 7 days.",
      pipeline: "Sales pipeline",
      pipeline_empty: "No open deals yet.",
      open_deals: "%{smart_count} open deal |||| %{smart_count} open deals",
    },
    portal: {
      menu: "My content",
      greeting: "Hi, %{name}",
      subtitle: "This is the content we are preparing for %{company}.",
      waiting_title: "Waiting for your approval",
      nothing_this_month: "There are no pieces for you to review this month.",
      no_selection: "Choose a piece in the calendar to review it.",
      approve: "Approve",
      request_changes: "Request changes",
      changes_placeholder: "Tell us what you would change",
      send_changes: "Send changes",
      comment_required: "Write what you would change before sending.",
      approved_toast: "Piece approved. Thank you!",
      changes_toast: "We sent your comments to the team.",
      waiting_hint: "This piece is waiting for your approval.",
      invite: {
        title: "Invite to the portal",
        description:
          "Create the client's access. You will get a one-time link to send by WhatsApp; with it they choose their password.",
        first_name: "First name",
        last_name: "Last name",
        email: "Email",
        create_link: "Create access link",
        link_ready: "Access link ready",
        link_hint:
          "Send it to the client. It works once; if it expires, create a new one here.",
        copy: "Copy link",
        copied: "Link copied",
        send_whatsapp: "Send by WhatsApp",
        whatsapp_message:
          "Hi %{name}! This is your access to the CMG360 portal, where you can review and approve your content: %{link}",
        new_link: "New link",
        people: "People with access",
        no_people: "Nobody from this client has access yet.",
        errors: {
          email_is_staff: "That email belongs to someone on the agency team.",
          email_other_client:
            "That email already has access to another client.",
          generic: "The access could not be created. Try again.",
        },
      },
    },
    theme: {
      dark: "Dark",
      label: "Theme",
      light: "Light",
      system: "System",
    },
    language: "Language",
    navigation: {
      label: "CRM navigation",
    },
    profile: {
      add_secondary_email: "Add an email",
      email_is_client: "%{email} is already a portal client. Use another email for the team.",
      email_taken: "%{email} is already used by another user",
      no_secondary_emails: "None",
      secondary_email_invalid: "%{email} is not a valid email address",
      secondary_email_is_primary: "%{email} is already your main address",
      secondary_email_taken: "%{email} is already used by another user",
      too_many_secondary_emails:
        "You cannot add more than 10 secondary email addresses",
      secondary_emails_help:
        "Other addresses you send emails from. Leave one empty to remove it.",
      inbound: {
        description:
          "You can start sending emails to your server's inbound email address, e.g. by adding it to the %{field} field. Atomic CRM will process the emails and add notes to the corresponding contacts.",
        title: "Inbound email",
      },
      mcp: {
        title: "MCP Server",
        description:
          "Use this URL to connect your AI assistant to your CRM data via the Model Context Protocol (MCP).",
      },
      password: {
        change: "Change password",
      },
      password_reset_sent:
        "A reset password email has been sent to your email address",
      record_not_found: "Record not found",
      title: "Profile",
      updated: "Your profile has been updated",
      update_error: "An error occurred. Please try again",
    },
    validation: {
      invalid_url: "Must be a valid URL",
      invalid_linkedin_url: "URL must be from linkedin.com",
    },
  },
} as const;

type MessageSchema<T> = {
  [K in keyof T]: T[K] extends string
    ? string
    : T[K] extends Record<string, unknown>
      ? MessageSchema<T[K]>
      : never;
};

type DeepPartial<T> = {
  [K in keyof T]?: T[K] extends Record<string, unknown>
    ? DeepPartial<T[K]>
    : T[K];
};

export type CrmMessages = MessageSchema<typeof englishCrmMessages>;
export type PartialCrmMessages = DeepPartial<CrmMessages>;
